import React, { useState, useEffect, useRef } from "react";
import { View, Animated, PanResponder } from "react-native";
import MaskedView from "@react-native-masked-view/masked-view";
import { FontAwesome } from "@expo/vector-icons";
import { SizableText } from "tamagui";

const MAX_RATING = 5;
const STAR_SIZE = 40;
const ACTIVE_COLOR = "#FFD700"; // Gold
const INACTIVE_COLOR = "#CCCCCC"; // Grey

const RatingComponent = ({
  maxRating = MAX_RATING,
  size = STAR_SIZE,
  defaultValue = 0,
  style = {},
  count = 0,
  disabled = false
}) => {
  const [rating, setRating] = useState(defaultValue);
  const animatedValue = useRef(new Animated.Value(defaultValue)).current;

  useEffect(() => {
    animatedValue.setValue(defaultValue);
  }, [defaultValue]);

  const handleRating = (value) => {
    if (!disabled) {
      setRating(value);
      Animated.timing(animatedValue, {
        toValue: value,
        duration: 200,
        useNativeDriver: false,
      }).start();
    }
  };

  const panResponder = useRef(
    PanResponder.create({
      onStartShouldSetPanResponder: () => !disabled,
      onPanResponderMove: (evt, gestureState) => {
        if (!disabled) {
          let newRating = Math.ceil(gestureState.moveX / (size + 5));
          if (newRating >= 0 && newRating <= maxRating) {
            handleRating(newRating);
          }
        }
      },
      onPanResponderRelease: () => { },
    })
  ).current;

  return (
    <View {...(!disabled && panResponder.panHandlers)} style={{ overflow: "visible", flexDirection: "row", flex: 1, gap: 40, padding: 0, ...style }}>
      <MaskedView
        style={{ flexDirection: "row", overflow: "visible" }}
        maskElement={
          <View style={{ flexDirection: "row" }}>
            {[...Array(maxRating)].map((_, i) => (
              <FontAwesome key={i} name="star" size={size} color="black" />
            ))}
          </View>
        }
      >
        {/* Inactive stars */}
        <View style={{ flexDirection: "row", backgroundColor: INACTIVE_COLOR }}>
          {[...Array(maxRating)].map((_, i) => (
            <FontAwesome key={i} name="star" size={size} color={INACTIVE_COLOR} />
          ))}
        </View>
        {/* Animated Active Stars */}
        <Animated.View
          style={{
            position: "absolute",
            flexDirection: "row",
            width: animatedValue.interpolate({
              inputRange: [0, maxRating],
              outputRange: ["0%", "100%"],
            }),
            overflow: "hidden",
          }}
        >
          {[...Array(maxRating)].map((_, i) => (
            <FontAwesome key={i} name="star" size={size} color={ACTIVE_COLOR} />
          ))}
        </Animated.View>
      </MaskedView>
    </View>
  );
};

export default RatingComponent;
